<template>
  <div class="gamescreen">
      <div class="machine" ref="machine">
            <input type="text" class="machinename" placeholder="Choisissez un nom" v-model="name">
            <div class="eyes eyesbase" ref="eyes"></div>
            <div class="inputlist" v-if="inputs.length || toomuch">
                <span  v-for="input in inputs" :key="input">{{input}}</span>
                <div class="warning-tm" v-if="toomuch">Too many inputs !</div>
            </div>
            <div class="credits">
                Crédits: {{credits}}
            </div>
            <div class="directionalinputs basesprite" ref="lever">
                <div class="up dirinput" @click="input('↑')"></div>
                <div class="right dirinput" @click="input('→')"></div>
                <div class="down dirinput" @click="input('↓')"></div>
                <div class="left dirinput" @click="input('←')"></div>
            </div>
            <div class="buttoninputs">
                <div class="btninput a" @click="input('a')"></div>
                <div class="btninput b" @click="input('b')"></div>
                <div class="btninput c" @click="input('c')"></div>
                <div class="btninput x" @click="input('x')"></div>
                <div class="btninput y" @click="input('y')"></div>
                <div class="btninput z" @click="input('z')"></div>
            </div>
            <div class="atkinput" @click="launchattack()"></div>
            <div class="coinslot"></div>
            <div class="coinscontainer">
                <div v-for="i in coins" :key="i" class="coin" @click="newcredit()"></div> 
            </div>
      </div>
      <div class="atkindicator" v-if="atkindicator">
          <h2>{{ attack.name }}</h2>
          <p>{{ attack.desc }}</p>
      </div>
      <div class="enemyscreen blueguy" ref="enemy" v-if="hasstarted">
          <span class="ehealth">Crédits: {{  ehealth  }}</span>
          <div class="enemyatk" ref="enemyatk">
              <h2>{{ eattack.name }}</h2>
              <p>{{ eattack.desc }}</p>
          </div>
      </div>
      <div class="beforeplaying" v-else>
          <h1>Contrôles :</h1>
          <p>Faites des combinaison de touches pour lancer des coups.</p>
          <p>Cliquez autour du stick pour ajouter une direction à votre combinaison.</p>
          <p>Cliquez sur les boutons A B C X Y Z pour les ajouter à votre combinaison.</p>
          <p>Cliquez sur "Attack!" pour lancer votre sort.</p>
          <p>C'est à vous de découvrir les combinaisons de touches ! </p> 
          <p>Cliquez sur les pièces pour ajouter des crédits.</p>
          <p>Souvenez-vous qu'une boule de feu dans Street Fighter c'est "↓ → punch" ;)</p>
          <p>Avant de commencer, entraînez-vous sur la borne, elle est déjà fonctionnelle !</p>
          <button @click="launchgame()">Je suis prêt !</button>
      </div>
          <div class="victory" v-if="victory">
              <h3>Bravo {{ name }} !</h3>
              <p>J'espère que vous avez trouvé le concept cool !</p>
              <p>PS: Désolé y'a pas de son lol</p>
              <p>(F5 pour rejouer)</p>
          </div>
          <div class="gameover" v-if="gameover">
              <h3>Arf {{ name }} !</h3>
              <p>Désolé j'ai fait le jeu trop dur je crois. Enfin, j'espère que vous avez quand même kiffé le concept !</p>
              <p>PS: Désolé y'a pas de son lol</p>
              <p>(F5 pour rejouer)</p>
          </div>
  </div>
  
</template>

<script>
export default {

    name: "GameField",
    data() {
        return {
            name: "",
            inputs: [],
            toomuch: false,
            attack: "",
            atkindicator: false,
            credits: 5,
            coins: 3,
            hasstarted: false,
            ehealth: 0,
            blueguy: {
                health: 6,
                attacks: ["WimpHit"],
                interval: 7000
            },
            greenguy: {
                health: 10,
                attacks: ["Guard", "FalconHit"],
                interval: 6000
            },
            pinkguy: {
                health: 20,
                attacks: ["Guard", "IronFisting", "Tectonique"],
                interval: 4500
            },
            eattack: {
                name: "",
                desc: ""
            },
            victory: false,
            gameover: false
        }
    },
    methods: {
        input(btn) {
            if(this.inputs.length<8) {
                this.toomuch = false;
                switch (btn) {
                    case "↑" :
                        this.$refs.lever.classList.remove("basesprite");
                        this.$refs.lever.classList.add("upsprite");
                        setTimeout(() => { this.$refs.lever.classList.remove("upsprite"); }, 200);
                        this.$refs.lever.classList.add("basesprite");
                    break;
                    case "→" :
                        this.$refs.lever.classList.remove("basesprite");
                        this.$refs.lever.classList.add("rightsprite");
                        setTimeout(() => { this.$refs.lever.classList.remove("rightsprite"); }, 200);
                        this.$refs.lever.classList.add("basesprite");
                    break;
                    case "↓" :
                        this.$refs.lever.classList.remove("basesprite");
                        this.$refs.lever.classList.add("downsprite");
                        setTimeout(() => { this.$refs.lever.classList.remove("downsprite"); }, 200);
                        this.$refs.lever.classList.add("basesprite");
                    break;
                    case "←" :
                        this.$refs.lever.classList.remove("basesprite");
                        this.$refs.lever.classList.add("leftsprite");
                        setTimeout(() => { this.$refs.lever.classList.remove("leftsprite"); }, 200);
                        this.$refs.lever.classList.add("basesprite");
                    break;
                }
                this.inputs.push(btn);
            }else {
                this.toomuch = true;
                this.inputs = [];
            }
        },
        launchattack() {
            if(this.inputs.length){
                const combo = this.inputs.join();
                console.log(combo);
                switch(combo) {
                    //Atoken (fireball)
                    case "↓,→,a" :
                    case "↓,→,b" :
                    case "↓,→,c" :
                        this.attack = {
                            name: "Hatoken",
                            desc: "1 dmg",
                        }
                        this.ehealth -= 1
                        this.etakesdmg()
                    break;
                    case "↑,↑,↓,↓,←,→,b,a" :
                        this.attack = {
                            name: "Coinami Code",
                            desc: "+ 6 pièces"
                        }
                        this.coins += 6   
                    break;
                    case "→,↓,→,a" :
                    case "→,↓,→,b" :
                    case "→,↓,→,c" :
                        this.attack = {
                            name: "Dragon Fist",
                            desc: "4 dmg, -1 credit"
                        }
                        this.ehealth -= 4;
                        this.credits -= 1;
                        this.etakesdmg()
                    break;
                    case "↓,←,↑,→,a" :
                    case "↓,←,↑,→,b" :
                    case "↓,←,↑,→,c" :
                        this.attack = {
                            name: "Tourbillon",
                            desc: "5 dmg"
                        }   
                        this.ehealth -= 5
                        this.etakesdmg()
                    break;
                    case "←,←" :
                    case "→,→" :
                        this.attack = {
                            name: "Dash",
                            desc: "+2 pièces"
                        }   
                        this.coins += 2
                    break;
                    case "←,→,x" :
                    case "←,→,y" :
                    case "←,→,z" :
                        this.attack = {
                            name: "Coup de l'oiseau tournoyant !",
                            desc: "3 dmg"
                        }   
                        this.ehealth -= 3
                        this.etakesdmg()
                    break;
                    case "↓,↑,x" :
                    case "↓,↑,y" :
                    case "↓,↑,z" :
                        this.attack = {
                            name: "Flash",
                            desc: "3 dmg"
                        }   
                        this.ehealth -= 3
                        this.etakesdmg()
                    break;
                    case "a,b,c" :
                    case "x,y,z" :
                        this.attack = {
                            name: "Heu, Ix ?",
                            desc: "2 dmg +1 pièce"
                        }   
                        this.ehealth -= 2;
                        this.coins += 1;
                        this.etakesdmg()
                    break;
                    default:
                        this.attack = {
                            name: "Ce n'est pas un combo :(",
                            desc: "Pensez aux classiques !"
                        }
                }
                this.atkindicator = true;
                this.$refs.eyes.classList.remove("eyesbase");
                this.$refs.eyes.classList.add("eyeswide");
                setTimeout(() => { this.$refs.eyes.classList.remove("eyeswide"); }, 2000);
                this.$refs.eyes.classList.add("eyesbase");
                setTimeout(() => { this.atkindicator = false }, 2000);
                setTimeout(() => { this.inputs = [] }, 500);
            }
        },
        newcredit() { 
            this.coins -= 1;
            this.credits += 1;
        },
        launchgame() {
            this.hasstarted = true;
            this.encounter(this.blueguy);
        },
        encounter(enemy) {
            this.ehealth = enemy.health;
            const nbrattacks = enemy.attacks.length;
            const enemyloop = setInterval(() => {    
                if(this.ehealth > 0){
                    let atk = Math.floor(Math.random() * nbrattacks)
                    this.enemyattack(enemy.attacks[atk]); 
                } else {
                    this.nextup(enemy)
                    clearInterval(enemyloop)
                }
            }, enemy.interval)

            },
        enemyattack(attack) {
            this.eattack.name = attack
            switch(attack) {
                case "WimpHit" : 
                    this.eattack.desc = "1 dmg";
                    this.playerdamage(1);
                break;
                case "FalconHit" : 
                    this.eattack.desc = "2 dmg";
                    this.playerdamage(2);
                break;
                case "Guard" : 
                    this.eattack.desc = "+2 crédits";
                    this.ehealth += 2;
                break;
                case "IronFisting" : 
                    this.eattack.desc = "3 dmg";
                    this.playerdamage(3);
                break;
                case "Tectonique" : 
                    this.eattack.desc = "1 dmg et + 3 crédit";
                    this.playerdamage(1);
                    this.ehealth += 6
                break;

            }
            setTimeout(() => { this.eattack.name = "???", this.eattack.desc= "" }, 1000)
        },
        playerdamage(dmg) {
            this.credits -= dmg;
            this.$refs.machine.classList.add("shaken");
            setTimeout(() => { this.$refs.machine.classList.remove("shaken")}, 1500);
            this.$refs.enemyatk.classList.add("hitmark");
            setTimeout(() => { this.$refs.enemyatk.classList.remove("hitmark")}, 1000);
        },
        nextup(enemy) {
            console.log(enemy);
            setTimeout(() => { 
                switch(enemy.health) {
                    case 6 : 
                        this.encounter(this.greenguy);
                        this.$refs.enemy.classList.remove("blueguy")
                        this.$refs.enemy.classList.add("greenguy")
                    break;
                    case 10 :
                        this.encounter(this.pinkguy);
                        this.$refs.enemy.classList.remove("greenguy")
                        this.$refs.enemy.classList.add("pinkguy")
                    break;
                    case 20 :
                        this.endgame("victory");
                        this.victory = true;
                    break;
                }
            }, 3000);
        },
        etakesdmg() {
            this.$refs.enemy.classList.add("shaken");
            setTimeout(() => { this.$refs.enemy.classList.remove("shaken")}, 1500);
        },
        endgame(state) {
            if(state == "victory"){
                this.victory = true;
            } else {
                this.gameover = true;
            }            
        },
       
    },
    watch: {
        credits: function() {
            if(this.credits <= 0) {
                console.log("test")
                this.endgame("lose")
            }
        }
    }
}
</script>

<style lang="scss">
.gamescreen {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .atkindicator {
        position: absolute;
        z-index: 10;
        width: 500px;
        top: 250px;
        left: 70px;
        text-align: center;
    }
}

.victory, .gameover {
    position: absolute;
    top: 250px;
    left: 700px;
    width: 500px;
    display: flex;
    flex-direction: column;
    background-color: white;
    border: 1px solid black;
    padding: 0 1rem 1rem 1rem;
    h3 {
        font-size: 2rem;
        font-weight: 900;
        color: white;
        background-color: black;
        padding: 0 0.5rem 0.2rem 0.5rem;
    }
    p {
        font-size: 1.2rem;
    }
}

.beforeplaying {
    position: absolute;
    top: 50px;
    left: 700px;
    width: 500px;
    display: flex;
    flex-direction: column;
    h1 {
        font-size: 2rem;
        font-weight: 900;
        color: white;
        background-color: black;
        padding: 0 0.5rem 0.2rem 0.5rem;
    }
    p {
        margin: 1.5rem 0 0 0;
        font-size: 1.2rem;
    }
    button {
        font-size: 2rem;
        color: white;
        background-color: black;
        padding: 0 0.5rem 0.2rem 0.5rem;
        margin: auto;
        margin-top: 3rem;
        border: none;
        transition: all 0.2s ease-in-out;
        &:hover {
            background-color: darkgray;
            cursor: pointer;
        }
        &:active {
            color: black;
            background-color: white;
        }
    }
}
.enemyscreen {
    position: absolute;
    top: 200px;
    left: 1000px;
    height: 600px;
    width: 300px;
    .ehealth {
        font-size: 5rem;
        position: absolute;
        top: -50px;
        color: darkred;
        width: 400px;
    }
    .enemyatk {
        position: absolute;
        text-align: center;;
        top: 100px;
        left: -200px;
    }
}

.blueguy {
    background-image: url("../../sprites/blueenemy.png");
    background-size: 100%;
    background-repeat: no-repeat;
}
.greenguy {
    background-image: url("../../sprites/greenenemy.png");
    background-size: 100%;
    background-repeat: no-repeat;
}
.pinkguy {
    background-image: url("../../sprites/pinkenemy.png");
    background-size: 100%;
    background-repeat: no-repeat;
}
.machinename {
    height: 4rem;
    border: none;
    width: 515px;
    background-color: rgba(0,0,0, 0);
    position: absolute;
    top: 20px;
    left: 30px;
    font-size: 3.5rem;
    text-align: center;
}
.machine {
    background-image: url("../../sprites/machine.png");
    background-size: contain;
    background-repeat: no-repeat;
    height: 145%;
    width: 700px;
    position: relative;
}
.eyes {
    background-size: contain;
    background-repeat: no-repeat;
    height: 100%;
    width: 250px;
    position: absolute;
    top: 180px;
    left: 160px;
}
.eyesbase {
    background-image: url("../../sprites/eyesbase.png");
}
.eyeswide {
    background-image: url("../../sprites/eyesround.png");
}
.eyesclosed {
    background-image: url("../../sprites/eyesclose.png");
}
.eyesdead {
    background-image: url("../../sprites/eyesdead.png");
}
.credits {
    position: absolute;
    color: white;
    background-color:#181818;
    padding: 0.1rem 0.5rem 0.1rem 0.5rem;
    z-index: 10;
    top: 700px;
    left: 105px;
    font-weight: 700;
}
.inputlist {
    background-color: rgba(0,0,0, 0.5);
    height: 1.4rem;
    position: absolute;
    top: 340px;
    left: 160px;
    padding: 0.2rem;
    span {
        color: white;
        font-weight: 900;
        margin-right: 0.5rem;
    }
}
.warning-tm {
    width: 250px;
    height: 1.4rem;
    position: absolute;
    top: -10px;
    left: 0;
    padding: 0.2rem;
    color: #fc7a57;
    font-weight: 700;
    text-align: center;
    font-size: 1.4rem;
}
.directionalinputs {
    background-size: contain;
    background-repeat: no-repeat;
    height: 125px;
    width: 125px;
    position: absolute;
    top: 425px;
    left: 75px;
    .up {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 0;
        left: 35px;
        z-index: 5;
    }
    .down {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 70px;
        left: 35px;
        z-index: 5;
    }
    .right {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 35px;
        left: 90px;
        z-index: 5;
    }
    .left {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 35px;
        left: -20px;
        z-index: 5;        
    }
}
.basesprite {
    background-image: url("../../sprites/stick_base.png");
}
.upsprite {
    background-image: url("../../sprites/stick_up.png");
}
.downsprite {
    background-image: url("../../sprites/stick_down.png");
}
.rightsprite {
    background-image: url("../../sprites/stick_right.png");
}
.leftsprite {
    background-image: url("../../sprites/stick_left.png");
}
.buttoninputs {
    .a {
        background-image: url("../../sprites/abase.png");
        background-size: 100%;
        background-repeat: no-repeat;
        height: 75px;
        width: 75px;
        position: absolute;
        top: 425px;
        left: 250px;
        &:active {
            background-image: url("../../sprites/apressed.png");
        }
    }
    .b {
        background-image: url("../../sprites/bbase.png");
        background-size: 100%;
        background-repeat: no-repeat;
        height: 75px;
        width: 75px;
        position: absolute;
        top: 425px;
        left: 300px;
        &:active {
            background-image: url("../../sprites/bpressed.png");
        }
    }
    .c {
        background-image: url("../../sprites/cbase.png");
        background-size: 100%;
        background-repeat: no-repeat;
        height: 75px;
        width: 75px;
        position: absolute;
        top: 425px;
        left: 350px;
        &:active {
            background-image: url("../../sprites/cpressed.png");
        }
    }
    .x {
        background-image: url("../../sprites/xbase.png");
        background-size: 100%;
        background-repeat: no-repeat;
        height: 75px;
        width: 75px;
        position: absolute;
        top: 475px;
        left: 225px;
        &:active {
            background-image: url("../../sprites/xpressed.png");
        }
    }
    .y {
        background-image: url("../../sprites/ybase.png");
        background-size: 100%;
        background-repeat: no-repeat;
        height: 75px;
        width: 75px;
        position: absolute;
        top: 475px;
        left: 275px;
        &:active {
            background-image: url("../../sprites/ypressed.png");
        }
    }
    .z {
        background-image: url("../../sprites/zbase.png");
        background-size: 100%;
        background-repeat: no-repeat;
        height: 75px;
        width: 75px;
        position: absolute;
        top: 475px;
        left: 325px;
        &:active {
            background-image: url("../../sprites/zpressed.png");
        }
    }
}

.attackbutton {
    //background-image: url("../../sprites/attack.png");
        background-size: contain;
        background-repeat: no-repeat;
        height: 100%;
        width: 100px;
        position: absolute;
        top: 450px;
        left: 450px;
}

.coinslot {
    background-image: url("../../sprites/coinslot.png");
    background-size: contain;
    background-repeat: no-repeat;
    height: 100%;
    width: 100px;
    position: absolute;
    top: 600px;
    left: 100px;
}

.coin {
    background-image: url("../../sprites/coin.png");
    background-size: contain;
    background-repeat: no-repeat;
    height: 75px;
    width: 75px;
    position: relative;
    display: inline-block;
    margin-right: -60px;
    &:hover {
        cursor: pointer;
    }
}

.coinscontainer {
    position: absolute;
    top: 610px;
    left: 250px;
    display: flex;
    flex-direction: row-reverse;
}



.btninput {
    height: 50px;
    width: 50px;
    position: absolute;
    top: 10px;
    left: 12px;
}

.atkinput {
    background-image: url("../../sprites/attack.png");
    height: 75px;
    width: 100px;
    background-size: 100%;
    position: absolute;
    top: 450px;
    left: 450px;
    &:active {
        background-image: url("../../sprites/attackpressed.png");
    }
}

.dirinput, .btninput, .atkinput {
    //border: solid 1px black;
    &:hover {
        cursor: pointer;
    }
}

//animations
@keyframes shake {
    0% { transform: translate(2px, 1px) rotate(0deg); } 
    10% { transform: translate(-1px, -2px) rotate(-1deg); }
    20% { transform: translate(-3px, 0px) rotate(1deg); }
    30% { transform: translate(0px, 2px) rotate(0deg); }
    40% { transform: translate(1px, -1px) rotate(1deg); }
    50% { transform: translate(-1px, 2px) rotate(-1deg); }
    60% { transform: translate(-3px, 1px) rotate(0deg); }
    70% { transform: translate(2px, 1px) rotate(-1deg); }
    80% { transform: translate(-1px, -1px) rotate(1deg); }
    90% { transform: translate(2px, 2px) rotate(0deg); }
    100% { transform: translate(1px, -2px) rotate(-1deg); }
}

.shaken {
    animation: shake 0.5s ease-out; 
}

@keyframes hitdisplay {
    0% { transform: scale(0)}
    100% { transform: scale(10) }
}

.hitmark {
    animation: hitdisplay 1s ease-in;
}

</style>